import { Module } from 'vuex'

import { getTariffNameByOptionKey } from './helpers'

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export default {
  namespaced: true,

  state: {
    tariffsMap: null,
  },

  mutations: {
    SET_TARIFFS_MAP(state:any, { tariffsMap }:any): void {
      state.tariffsMap = tariffsMap
    },
  },

  actions: {
    // tariffName({ state }, { option }): string | undefined {
    //   if (state.tariffsMap) {
    //     return getTariffNameByOptionKey(state.tariffsMap, option)
    //   }
    //   throw new Error('"tariffsMap" is null. \n Please fill it.')
    // },
  },
} as unknown as Module<string, any>
